import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkComponent } from './network/network.component';
import { SecurityComponent } from './security/security.component';
import { ManagedComponent } from './managed/managed.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [NetworkComponent, SecurityComponent, ManagedComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class ManagedModule { }
